import { type Enum } from '@webapp/infrastructure/types/Enum'

export const OrderItemTypes = {
  ONE_TIME: 0,
  RECURRING: 1,
  BLANKET: 2,
} as const

export type OrderItemTypeEnum = Enum<typeof OrderItemTypes>
